import React from "react";
import { parseLearningContentVideoUrl } from "./utils/learningContent";
import "./LearningContentVideoPlayer.css";

const LearningContentVideoPlayer = ({ block, preview = false }) => {
  let video;
  try {
    video = parseLearningContentVideoUrl(block.url);
  } catch (_error) {
    return <p className="learning-content-video-unavailable" role="status">This video link is unavailable.</p>;
  }
  const playerTitle = block.title || "Learning Content video";
  return (
    <figure className={`learning-content-video${preview ? " is-preview" : ""}`}>
      {block.title && <figcaption>{block.title}</figcaption>}
      <div className="learning-content-video-frame">
        {video.kind === "youtube" ? (
          <iframe
            src={video.playbackUrl}
            title={playerTitle}
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            allow="encrypted-media; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <video src={video.playbackUrl} title={playerTitle} aria-label={playerTitle} controls preload="metadata">
            Your browser cannot play this video.
          </video>
        )}
      </div>
      <a href={video.fallbackUrl} target="_blank" rel="noopener noreferrer">
        Open video in a new tab if it does not play here
      </a>
    </figure>
  );
};

export default LearningContentVideoPlayer;
